import OperationalHistoryExport from './OperationalHistoryExport';

export default OperationalHistoryExport;